import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';
import musicFile from '../../asset/music/jimin.mp3';


const ChoHyeJung = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "한희수 ❤️ 조혜정 결혼합니다.";
    const openDesc = "7월26일 오후 6시30분";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/234/thumb.jpg";

    const lng = 127.06555816565238;
    const lat = 37.50336622551557;

    const placeTelNum = "02-539-0400";

    const parents = [
        {groom : "임채호 · 이은경의 아들"},
        {bride : "안병규 · 김현주의 딸"}
    ]

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const forBus = "휘문고교사거리 (대치동은마아파트방면)\n총회회관.휘문고입구 (삼성역방면)\n\n간선 343,401 \n지선 4318,4319 \n일반 11-3,917\n직행 500-2, 9407, 9607, 9607";
    const forSubway = "2호선 삼성역 3번 출구 30m 전방 셔틀버스 운행 (수시 \n운행, 도보 이용 시 7분 소요)";
    const forCar = "강남구 영동대로 325 노블발렌티 대치점 (대치동 983-1)\n본 건물 및 인근 건물 2시간 무료주차 본 건물 주차 통로가 \n좁으니 주의 바랍니다.";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #EFD140
    // #EB9217
    // #ff8faf
    // #E36402
    // #88abd1
    // 연퍼플 #e4aced
    // 빈티지 연퍼플 #bf9cd8
    // 소라 : #88abd1
    // #edacb1
    // #D77599
    // #BC5078
    // #ff8faf
  //  #E2396A
  // #F77BAD
    // #ffb0d2 쿨 연핑크
    const conceptStyle = {
        // spring 그린 c
        concept: "SPRING",
        titleColor: "#99C11D",
        pointColor: "#99C11D",
        btnBgColor: "#b4d450",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#ebf4e9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "저희 결혼합니다.";

    const msg1 = "풀들이 향기를 머금은 계절";
    const msg2 = "오랜 친구처럼 \n때론 처음 만나는 사람처럼";
    const msg3 = "사랑하는 사람을 만나 \n한 길을 걸어가고자 합니다.";
    const msg4 = "걸음마다 꽃이 피어날 수 있도록\n\n그 시작의 첫걸음에 함께 하시어\n축복으로 채워주신다면 감사하겠습니다.\n\n";

    const groomAccountList = [
        {
            role: "신랑",
            name: "한희수",
            bank: "우리은행",
            accountNumber : "126-753631-02-101",
            isKakao : false
        }
        // ,{
        //     role: "신랑 부",
        //     name: "임채호",
        //     bank: "경남은행",
        //     accountNumber : "574-22-0157453",
        //     isKakao :  false
        // }
        ,{
            role: "신랑 모",
            name: "정명숙",
            bank: "우리은행",
            accountNumber : "126-233359-12-001",
            isKakao :false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "조혜정",
            bank: "카카오뱅크",
            accountNumber : "3333-19-3632583",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej9CvBDgx"
        }
        ,{
            role: "신부 부",
            name: "조기행",
            bank: "국민은행",
            accountNumber : "054-24-0222-756",
            isKakao :false
        }
        ,{
            role: "신부 모",
            name: "이미영",
            bank: "신한은행",
            accountNumber : "110-002-561020",
            isKakao : false
        }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "임우섭",
            call: "010-6588-4646"
        }
        ,{
            role: "신랑 부",
            name: "임채호",
            call: "010-4585-1286"
        }
        ,{
            role: "신랑 모",
            name: "이은경",
            call: "010-3461-2823"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "안지민",
            call: "010-9372-3730"
        }
        ,{
            role: "신부 부",
            name: "안병규",
            call: "010-2578-3558"
        },
        {
            role: "신부 모",
            name: "김현주",
            call: "010-5501-3730"
        }
    ]

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "완~전ㅎㅎ",
            brideAnswer: "못 잊어ㅎㅎ"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "나 장가 간다!",
            brideAnswer: "나 시집 간다!"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "사이 좋게",
            brideAnswer: "잘 지내자"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "지혜롭게!",
            brideAnswer: "현명하게!"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "잘 살게요❤️",
            brideAnswer: "감사합니다❤️"
        }
    ]


    const informationList =[
        {
            title : "포토부스 안내",
            content : "소중한 날을 기록할 수 있도록\n포토부스를 준비했습니다.\n한장은 방명록에 ,\n한장은 추억으로 간직해주세요."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#99C11D"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicFile}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    {/* <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"153px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        {/* <Information pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forCar={forCar} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ChoHyeJung;